
import { generateClient } from "aws-amplify/api";
import {
  listPProduccions, listPlaneacions, listUbicacions, listRecibaSeriales, listLocacions, listEmbarques, listTickets,
  listUsuarios, listAutorizaciones, listCotizacions, listClientes, listProductos, listTicketStatuses, getPProduccion, getPlaneacion,
  getRecibaSeriales, getProducto, listRecibas, getReciba, getLocacion, listRecuperacions, getRecuperacion, getEmbarque,
  listEmbarqueSeriales, getEmbarqueSeriales, listCotizacionAreas, getCotizacionArea, getCotizacion, getCliente,
  listClienteContactos, getClienteContactos, listPProduccionGenerals, getPProduccionGeneral, listNotificaciones, listNotificacionesNuevas, getNotificaciones, getTickets,
  listRecibaSerialesMPS,
  getRecibaSerialesMP,
  listPlaneacionGenerals,
  getPlaneacionGeneral,
  listPlaneacionBases,
  getPlaneacionBase,
  listPlaneacionBaseGenerals,
  getPlaneacionBaseGeneral,
  listFacturaConceptoGenerals,
  getFacturaConceptoGeneral,
  listCambios,
  getCambios,
  listResumenOperacions,
  getResumenOperacion,
  listADatosROperacions,
} from "../../graphql/queries";

const API = generateClient();
//import { API } from "aws-amplify";
export async function GetPProduccion(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listPProduccions,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listPProduccions.items;
    nextToken = await apiOData.data.listPProduccions.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}

//Obtiene las notifiaciones
export async function GetNotificaciones(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listNotificaciones,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listNotificaciones.items;
    nextToken = await apiOData.data.listNotificaciones.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
//Obtiene el plan de producción por ID
export async function GetNotificacionesID(ID) {
  const apiOData = await API.graphql({ query: getNotificaciones, variables: { id: ID }, });
  const odatosID = await apiOData.data.getNotificaciones;
  return odatosID;
}
//Obtiene las notificaciones nuevas
export async function GetNotificacionesNuevas(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listNotificacionesNuevas,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listNotificacionesNuevas.items;
    nextToken = await apiOData.data.listNotificacionesNuevas.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
//Obtiene el plan de producción por ID
export async function GetPProduccionID(ID) {
  const apiOData = await API.graphql({
    query: getPProduccion,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getPProduccion;
  return odatosID;
}
export async function GetPProduccionGeneral(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listPProduccionGenerals,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listPProduccionGenerals.items;
    nextToken = await apiOData.data.listPProduccionGenerals.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
//Obtiene el plan de producción por ID
export async function GetPProduccionGeneralID(ID) {
  const apiOData = await API.graphql({
    query: getPProduccionGeneral,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getPProduccionGeneral;
  return odatosID;
}
//Obtiene los datos de ResumenOperacion
export async function GetResumenOperacion(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listResumenOperacions,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listResumenOperacions.items;
    nextToken = await apiOData.data.listResumenOperacions.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
//Obtiene el plan de producción por ID
export async function GetResumenOperacionID(ID) {
  const apiOData = await API.graphql({
    query: getResumenOperacion,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getResumenOperacion;
  return odatosID;
}
//Obtiene los datos de ADatosROperacion
export async function GetADatosROperacion(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listADatosROperacions,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listADatosROperacions.items;
    nextToken = await apiOData.data.listADatosROperacions.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
//Obtiene el plan de producción por ID
export async function GetADatosROperacionID(ID) {
  const apiOData = await API.graphql({
    query: getResumenOperacion,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getResumenOperacion;
  return odatosID;
}
export async function GetPlaneacion(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listPlaneacions,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listPlaneacions.items;
    nextToken = await apiOData.data.listPlaneacions.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}

export async function GetPlaneacionID(ID) {
  const apiOData = await API.graphql({
    query: getPlaneacion,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getPlaneacion;
  return odatosID;
}

export async function GetPlaneacionGeneral(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listPlaneacionGenerals,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listPlaneacionGenerals.items;
    nextToken = await apiOData.data.listPlaneacionGenerals.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetPlaneacionGeneralID(ID) {
  const apiOData = await API.graphql({
    query: getPlaneacionGeneral,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getPlaneacionGeneral;
  return odatosID;
}

export async function GetPlaneacionBase(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listPlaneacionBases,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listPlaneacionBases.items;
    nextToken = await apiOData.data.listPlaneacionBases.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}

export async function GetPlaneacionBaseID(ID) {
  const apiOData = await API.graphql({
    query: getPlaneacionBase,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getPlaneacionBase;
  return odatosID;
}

export async function GetPlaneacionBaseGeneral(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listPlaneacionBaseGenerals,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listPlaneacionBaseGenerals.items;
    nextToken = await apiOData.data.listPlaneacionBaseGenerals.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetPlaneacionBaseGeneralID(ID) {
  const apiOData = await API.graphql({
    query: getPlaneacionBaseGeneral,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getPlaneacionBaseGeneral;
  return odatosID;
}

export async function GetTickets(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listTickets,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listTickets.items;
    nextToken = await apiOData.data.listTickets.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}

export async function GetTicketID(ID) {
  const apiOData = await API.graphql({
    query: getTickets,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getTickets;
  return odatosID;
}

export async function GetTicketsStatus(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listTicketStatuses,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listTicketStatuses.items;
    nextToken = await apiOData.data.listTicketStatuses.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}

export async function GetRecuperacion(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listRecuperacions,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listRecuperacions.items;
    nextToken = await apiOData.data.listRecuperacions.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetRecuperacionID(ID) {
  const apiOData = await API.graphql({
    query: getRecuperacion,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getRecuperacion;
  return odatosID;
}
export async function GetUbicacion(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listUbicacions,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listUbicacions.items;
    nextToken = await apiOData.data.listUbicacions.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetReciba(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listRecibas,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listRecibas.items;
    nextToken = await apiOData.data.listRecibas.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetRecibaID(ID) {
  const apiOData = await API.graphql({ query: getReciba, variables: { id: ID } });
  const odatosID = await apiOData.data.getReciba;
  return odatosID;
}
export async function GetRecibaSeriales(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listRecibaSeriales,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listRecibaSeriales.items;
    nextToken = await apiOData.data.listRecibaSeriales.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetRecibaSerialesID(ID) {
  const apiOData = await API.graphql({
    query: getRecibaSeriales,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getRecibaSeriales;
  return odatosID;
}
export async function GetRecibaSerialesMP(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listRecibaSerialesMPS,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listRecibaSerialesMPS.items;
    nextToken = await apiOData.data.listRecibaSerialesMPS.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetRecibaSerialesIDMP(ID) {
  const apiOData = await API.graphql({
    query: getRecibaSerialesMP,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getRecibaSerialesMP;
  return odatosID;
}
export async function GetLocaciones(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listLocacions,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listLocacions.items;
    nextToken = await apiOData.data.listLocacions.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetLocacionesID(ID) {
  const apiOData = await API.graphql({ query: getLocacion, variables: { id: ID } });
  const odatosID = await apiOData.data.getLocacion;
  return odatosID;
}
export async function GetEmbarques(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listEmbarques,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listEmbarques.items;
    nextToken = await apiOData.data.listEmbarques.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetEmbarquesID(ID) {
  const apiOData = await API.graphql({ query: getEmbarque, variables: { id: ID } });
  const odatosID = await apiOData.data.getEmbarque;
  return odatosID;
}
export async function GetEmbarquesSeriales(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listEmbarqueSeriales,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listEmbarqueSeriales.items;
    nextToken = await apiOData.data.listEmbarqueSeriales.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetEmbarquesSerialesID(ID) {
  const apiOData = await API.graphql({
    query: getEmbarqueSeriales,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getEmbarqueSeriales;
  return odatosID;
}
export async function GetFacturaConceptoGeneral(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listFacturaConceptoGenerals,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listFacturaConceptoGenerals.items;
    nextToken = await apiOData.data.listFacturaConceptoGenerals.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetFacturaConceptoGeneralID(ID) {
  const apiOData = await API.graphql({
    query: getFacturaConceptoGeneral,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getFacturaConceptoGeneral;
  return odatosID;
}
export async function GetUsuarios(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listUsuarios,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listUsuarios.items;
    nextToken = await apiOData.data.listUsuarios.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetAutorizaciones(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listAutorizaciones,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listAutorizaciones.items;
    nextToken = await apiOData.data.listAutorizaciones.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}

export async function GetCotizaciones(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listCotizacions,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listCotizacions.items;
    nextToken = await apiOData.data.listCotizacions.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetCotizacionID(ID) {
  const apiOData = await API.graphql({
    query: getCotizacion,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getCotizacion;
  return odatosID;
}
export async function GetCotizacionArea(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listCotizacionAreas,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listCotizacionAreas.items;
    nextToken = await apiOData.data.listCotizacionAreas.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetCotizacionAreaID(ID) {
  const apiOData = await API.graphql({
    query: getCotizacionArea,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getCotizacionArea;
  return odatosID;
}
export async function GetClientes(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listClientes,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listClientes.items;
    nextToken = await apiOData.data.listClientes.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetClientesID(ID) {
  const apiOData = await API.graphql({ query: getCliente, variables: { id: ID } });
  const odatosID = await apiOData.data.getCliente;
  return odatosID;
}
export async function GetClienteContactos(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listClienteContactos,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listClienteContactos.items;
    nextToken = await apiOData.data.listClienteContactos.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetClienteContactosID(ID) {
  const apiOData = await API.graphql({
    query: getClienteContactos,
    variables: { id: ID },
  });
  const odatosID = await apiOData.data.getClienteContactos;
  return odatosID;
}
export async function GetProductos(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listProductos,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listProductos.items;
    nextToken = await apiOData.data.listProductos.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetProductosID(ID) {
  const apiOData = await API.graphql({ query: getProducto, variables: { id: ID } });
  const odatosID = await apiOData.data.getProducto;
  return odatosID;
}
export async function GetCambios(filter) {
  var nextToken = null;
  var apiData = [];
  do {
    const apiOData = await API.graphql({
      query: listCambios,
      variables: { filter: filter, limit: 100000000, nextToken },
    });
    const odatos = await apiOData.data.listCambios.items;
    nextToken = await apiOData.data.listCambios.nextToken;
    apiData = await [...apiData, ...odatos];
  } while (nextToken != null);

  return apiData;
}
export async function GetCambiosID(ID) {
  const apiOData = await API.graphql({ query: getCambios, variables: { id: ID } });
  const odatosID = await apiOData.data.getCambios;
  return odatosID;
}
